// Generated by CoffeeScript 1.12.7
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

define('sp/ui/questions/question_forms/scale',['require','underscore','nouislider','../question_form','sp/utilities/restrict_numeric'],function(require) {
  var QuestionForm, Scale, _, noUiSlider, restrictNumeric;
  _ = require('underscore');
  noUiSlider = require('nouislider');
  QuestionForm = require('../question_form');
  restrictNumeric = require('sp/utilities/restrict_numeric');
  return Scale = (function(superClass) {
    extend(Scale, superClass);

    function Scale() {
      this.minInputKeyupHandler = bind(this.minInputKeyupHandler, this);
      this.minInputChangeHandler = bind(this.minInputChangeHandler, this);
      return Scale.__super__.constructor.apply(this, arguments);
    }

    Scale.prototype.tagName = "ul";

    Scale.prototype.className = "scale-container";

    Scale.prototype.$slider = null;

    Scale.prototype.range = false;

    Scale.prototype.defaultMin = 0;

    Scale.prototype.defaultMax = 10;

    Scale.prototype.initialize = function(options) {
      return Scale.__super__.initialize.call(this, options);
    };

    Scale.prototype.render = function() {
      var $minLabel, labelText;
      Scale.__super__.render.call(this);
      this.range = this.model.get("type") === 'range';
      if (this.model.get("properties").min) {
        this.defaultMin = Number(this.model.get("properties").min);
      }
      if (this.model.get("properties").max) {
        this.defaultMax = Number(this.model.get("properties").max);
      }
      if (this.defaultMin >= this.defaultMax) {
        this.defaultMin = this.defaultMax - 1;
      }
      this.$slider = $("<div>").empty().appendTo($('<li>').appendTo(this.el));
      noUiSlider.create(this.$slider[0], {
        step: 1,
        connect: this.range ? true : 'lower',
        start: this.range ? [this.defaultMin, this.defaultMax] : this.defaultMin,
        range: {
          min: this.defaultMin,
          max: this.defaultMax
        },
        cssPrefix: 'sp-slider-'
      });
      labelText = this.definitions.scaleMin || "Value";
      $minLabel = $("<label>").attr({
        "for": "min-value[" + (this.model.get('_id')) + "]",
        "class": "min-value-label"
      }).text(labelText);
      this.$minInput = $("<input>").appendTo(this.$el).attr({
        type: "number",
        name: "min-value[" + (this.model.get('_id')) + "]",
        id: "min-value[" + (this.model.get('_id')) + "]",
        "class": "min-value",
        min: this.defaultMin,
        max: this.defaultMax + 1,
        'aria-labelledby': "question-title-" + (this.model.get('_id'))
      }).prop('required', this.model.get('required') || false).val(this.values[0]).keypress(restrictNumeric).keyup(this.minInputKeyupHandler).change(this.minInputChangeHandler);
      $('<li>').addClass('min-value-container').append([$minLabel, this.$minInput]).appendTo(this.el);
      this.initListeners();
      return this.$el;
    };

    Scale.prototype.minInputChangeHandler = function(e) {
      if (Number(e.target.value) < Number(this.model.get("properties").min)) {
        e.target.value = this.model.get("properties").min;
      } else if (Number(e.target.value) > Number(this.model.get("properties").max)) {
        e.target.value = this.model.get("properties").max;
      }
      this.values[0] = e.target.value;
      return this.$slider[0].noUiSlider.set(Number(this.values[0]));
    };

    Scale.prototype.minInputKeyupHandler = function(e) {
      return this.setValues([e.target.value]);
    };

    Scale.prototype.setMinValue = function(val) {
      this.values[0] = Number(val);
      return this.$minInput.val(this.values[0]);
    };

    Scale.prototype.setMaxValue = function(val) {
      this.values[1] = Number(val);
      return this.$maxInput.val(this.values[1]);
    };

    Scale.prototype.setValues = function(vals) {
      if ($.isNumeric(vals[0])) {
        this.values[0] = Number(vals[0]);
        this.$minInput.val(this.values[0]);
        this.$slider[0].noUiSlider.set(this.values[0]);
        return this.trigger(QuestionForm.UPDATE_EVENT, this);
      }
    };

    Scale.prototype.initListeners = function() {
      return this.$slider[0].noUiSlider.on("slide", (function(_this) {
        return function(values, handle, unencoded) {
          if (values != null) {
            if (values[0] != null) {
              _this.setMinValue(values[0]);
            }
            if (values[1] != null) {
              _this.setMaxValue(values[1]);
            }
          }
          return _this.trigger(QuestionForm.UPDATE_EVENT, _this);
        };
      })(this));
    };

    return Scale;

  })(QuestionForm);
});

